import type { FlatpageDto } from '@features/legal/api/flatpages.dto'
import type { LegalPage } from '@features/legal/types'

/** Преобразует backend DTO простой страницы в доменную legal-модель. */
export const mapFlatpageDto = (dto: FlatpageDto): LegalPage => ({
  content: dto.content,
  title: dto.title,
  seoTitle: dto.seo_title || null,
  seoDescription: dto.seo_description || null,
  seoKeywords: dto.seo_keywords || null,
  url: dto.url,
})
